import { EventTriggerType, Trigger } from '../../domain';
import { GEARBOX_MODE_LABELS, GearboxMode } from '../../types';
import { TriggerType } from './components/TriggerType';
import { TriggerValueDetail } from './components/TriggerValueDetail';

interface Props {
  trigger: Trigger;
  triggerType: EventTriggerType;
}

export const GearboxTriggerDetails = ({ trigger, triggerType }: Props) => {
  const rawMode = trigger.context?.gearboxMode ?? trigger.context?.mode;
  const modeLabel = rawMode ? (GEARBOX_MODE_LABELS[rawMode as GearboxMode] ?? String(rawMode).replace(/-/g, ' ')) : '';

  return (
    <div className="tw:flex tw:flex-row tw:gap-6">
      <TriggerType eventType={triggerType} />
      {modeLabel && <TriggerValueDetail label="Mode" value={modeLabel} />}
    </div>
  );
};
